/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React, {
    useState, useContext, useCallback, useEffect, useRef,
} from 'react';
import moment from 'moment';
import { motion } from 'framer-motion';
import AddBannerModal from './AddBannerModal';
import FilterModal from './FilterModal';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../../Components/Context/HeaderContext';
import AreaListSkeleton from '../MISReports/AreaWiseCustomerReport/AreaListSkeleton';
import { GenerateDate, GenerateDateandTime } from '../../redux/helper/DateConverter';
import Pagination from '../../Components/Pagination';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import DeleteBannerModal from './DeleteBannerModal';
import ActivateBanner from './ActivateBanner';
import { AccessPrevilegesFunction } from '../../constants/GlobalAccessFunction';

function PromotionList() {
    const {
        SetSuccessMessage,
        setcolorValue,
    } = useContext(HeaderContext);
    const [promotionList, setPromotionList] = useState([]);
    const [threeDotLoader, setThreeDotsLoader] = useState(false);
    const [addBannerModal, setAddbannerModal] = useState(false);
    const [activateBannerModal, setActivateBannerModal] = useState(false);
    const [deleteBannermodal, setDeleteBannerModal] = useState(false);
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [sortType, setsortType] = useState('created_at+desc');
    const [activeObj, setActiveObj] = useState({});
    const [filterModal, setFilterModal] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [emptyData, setEmptyData] = useState(false);
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [isEditId, setisEditId] = useState('');
    const [isEditState, setIsEditState] = useState(false);
    const [selectedBannner, setSelectedBanner] = useState({});
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    // const [bannerselected, setbannerselected] = useState({
    //     banner_start_date: '',
    //     banner_end_date: '',
    // });
    const [bannerDetails, setBannerDetails] = useState({
        title: '',
        description: '',
        start_date: '',
        end_date: '',
        link: '',
        desktop_url: '',
        mobile_url: '',
        tab_url: '',
    });
    const [errorState, setErrorState] = useState({
        title: '',
        description: '',
        start_date: '',
        end_date: '',
        desktop_url: '',
        mobile_url: '',
        tab_url: '',
    });
    const [updateObj, setUpdateObj] = useState({});
    const [errorIndication, setErrorIndication] = useState(false);

    const validate = () => {
        let isvalid = true;
        Object.keys(bannerDetails).forEach((value) => {
            switch (value) {
            case 'title':
            case 'description':
            case 'start_date':
            case 'end_date':
            case 'desktop_url':
            case 'mobile_url':
            case 'tab_url':
                if (bannerDetails[value] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: `${value} is required`,
                    }));
                    isvalid = false;
                    setErrorIndication(true);
                }
                break;
            default: break;
            }
        });
        return isvalid;
    };

    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage, sortType]);

    const handleFetchPromotionList = useCallback((() => {
        distributorService.Promotions(currentPage, sortType, debouncedSearch, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setPromotionList(response.data.data.Items);
                setalldata(response);
                setCurrentPage(response.data.data.current_page);
                setTotalPage(response.data.data.number_of_pages);
            } else {
                setLoading(false);
                setalldata([]);
            }
        });
    }), [currentPage, debouncedSearch, sortType, filterValue]);

    const handleUploadBanner = async () => {
        if (validate()) {
            setThreeDotsLoader(true);
            const payload = {
                title: bannerDetails.title,
                description: bannerDetails.description,
                start_date: moment(bannerDetails.start_date).valueOf() / 1000,
                end_date: moment(bannerDetails.end_date).valueOf() / 1000,
                link: bannerDetails.link,
                desktop_url: bannerDetails.desktop_url,
                mobile_url: bannerDetails.mobile_url,
                tab_url: bannerDetails.tab_url,
            };
            let data;
            if (isEditState) {
                data = await distributorService.UpdatePromotions(selectedBannner.promotion_id, payload);
            } else {
                data = await distributorService.CreatePromotions(payload);
            }
            if (data.error === false) {
                setAddbannerModal(false);
                setThreeDotsLoader(false);
                handleFetchPromotionList();
                SetSuccessMessage(data.data.message);
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
                setBannerDetails({});
            } else {
                SetSuccessMessage(data.data.message);
                setAddbannerModal(false);
                setThreeDotsLoader(false);
                handleFetchPromotionList();
                setcolorValue('red');
                setTimeout(() => {
                    SetSuccessMessage('');
                    setcolorValue('');
                }, 2000);
                setBannerDetails({});
            }
        }
    };

    const handleFilter = (filterUrl) => {
        if (filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleAddBanner = () => {
        setAddbannerModal(true);
    };

    const handleDelete = (item) => {
        setSelectedBanner(item);
        setDeleteBannerModal(true);
    };

    const handleUpdateBanner = (item) => {
        setSelectedBanner(item);
        setIsEditState(true);
        setAddbannerModal(true);
    };

    const handleUpdatePromotion = useCallback(((id, body) => {
        setThreeDotsLoader(true);
        distributorService.UpdatePromotions(id, body).then((response) => {
            SetSuccessMessage(response.data.message);
            setTimeout(() => {
                SetSuccessMessage('');
            }, 2000);
            setActivateBannerModal(false);
            setThreeDotsLoader(false);
            handleFetchPromotionList();
        });
    }));

    const handleDeletePromotion = useCallback(((id) => {
        setThreeDotsLoader(true);
        distributorService.DeletePromotions(id).then((response) => {
            SetSuccessMessage(response.data.message);
            setTimeout(() => {
                SetSuccessMessage('');
            }, 2000);
            setDeleteBannerModal(false);
            setThreeDotsLoader(false);
            handleFetchPromotionList();
        });
    }));

    const previlegeassigned = AccessPrevilegesFunction('manage_banners');

    useEffect(() => {
        handleFetchPromotionList();
    }, [handleFetchPromotionList]);

    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Promotion/Campaign Banners</h5>
                <div className="flex items-center">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{ border: '2px solid #E9EDF4' }}
                        data-testid="filter-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input onInput={(e) => setsearchValue(e.target.value)} type="text" name="search" id="search" data-testid="search-banner" className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]" placeholder="Search" />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    {previlegeassigned === true
                        ? (
                            <button
                                type="button"
                                id="exportDropdown"
                                data-testid="add-new-banner-btn"
                                data-bs-toggle="modal"
                                data-bs-target="#add-Banner-modal"
                                aria-expanded="false"
                                className="dropdown-toggle h-[35px] mr-2 text-xs2 font-semibold text-[#FFFFFF] w-[107px] bg-[#555259] border border-[#555259] rounded-lg"
                                onClick={() => handleAddBanner()}
                            >
                                Add New
                            </button>
                        ) : null}
                </div>
            </div>
            {loading ? <AreaListSkeleton /> : (
                <div>
                    {promotionList.length > 0
                    && (
                        <div
                            className="overflow-auto dropdown-menu pb-7 relative z-[10] h-customh4"
                            style={{ height: 'calc(100vh - 298px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="sticky top-0 left-0 z-[30]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-[5px] px-6 rounded-bl-lg rounded-tl-lg min-w-[250px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-sm29 font-bold text-[#FFFFFF]">
                                                Title
                                            </span>
                                        </th>
                                        <th scope="col" className="pt-3 pb-[5px] px-7 min-w-[370px] more-lines">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Description
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[200px] text-center">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Start Date
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'start_date+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'start_date+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'start_date+asc') {
                                                                setsortType('start_date+desc');
                                                            } else if (sortType === 'start_date+desc') {
                                                                setsortType('start_date+asc');
                                                            } else {
                                                                setsortType('start_date+asc');
                                                            }
                                                        // setCurrentPage(1);
                                                        // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                End Date
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'end_date+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'end_date+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'end_date+asc') {
                                                                setsortType('end_date+desc');
                                                            } else if (sortType === 'end_date+desc') {
                                                                setsortType('end_date+asc');
                                                            } else {
                                                                setsortType('end_date+asc');
                                                            }
                                                        // setCurrentPage(1);
                                                        // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[180px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                URL
                                            </span>
                                        </th>
                                        <th scope="col" className="pt-3 pb-[5px] px-7 min-w-[370px] more-lines">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Status
                                            </span>
                                        </th>
                                        <th scope="col" className="rounded-tr-lg rounded-br-lg sticky top-0 right-0 bg-[#555259] py-[5px] px-7 min-w-[100px]">
                                            <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center" />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {promotionList.length > 0 && promotionList.map((item, i) => (
                                        <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                            <td
                                                data-testid={`banner-title-${i}`}
                                                className="text-sm font-normal text-[#090406] py-[5px] px-7 sticky left-0 flex justify-center items-center pt-4 bg-[#FDFDFE99]
                                    position: -webkit-sticky; position: sticky; top: 0; display: revert;text-align: center; z-[1]"
                                                style={{ backdropFilter: 'blur(22.5px)', background: 'rgba(253, 253, 254, 0.6)' }}
                                            >
                                                {item?.title}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                {item?.description}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                {GenerateDateandTime(item?.start_date)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-[5px] px-7">
                                                {GenerateDateandTime(item?.end_date)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] text-center py-[5px] px-7">
                                                {item?.link}
                                            </td>
                                            <td data-testid={`banner-status-${i}`} className="text-sm font-normal text-[#090406] text-center py-[5px] px-7">
                                                {item?.status === 1 ? 'Active' : 'Inactive'}
                                            </td>
                                            <td
                                                onClick={() => {
                                                    if (isEditId === i) {
                                                        setisEditId('');
                                                        setActiveObj(item);
                                                    } else {
                                                        setisEditId(i);
                                                    }
                                                }}
                                                className="py-2.5 px-7 sticky right-0 bg-[#FDFDFE99]"
                                                style={{ backdropFilter: 'blur(22.5px)', zIndex: `${20 - i}` }}
                                            >
                                                <div className="dropdown relative text-center">
                                                    <button className="dropdown-toggle" type="button" id="dropdownMenuButton111" data-testid={`banner-action-menu-${i}`} data-bs-toggle="dropdown" aria-expanded="false">
                                                        <img src="/images/more-vertical.svg" alt="icon" className="cursor-pointer" />
                                                    </button>
                                                    {isEditId !== '' && (
                                                        <ul className={`dropdown-menu min-w-[120] ${isEditId === i ? 'show' : 'hidden'} absolute bg-[#FFFFFF] rounded-[10px] shadow-s2 right-[40px]`} aria-labelledby="dropdownMenuButton111">
                                                            <li
                                                                className="px-5 pb-1.5 pt-5"
                                                                data-testid={`banner-edit-${i}`}
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#edit-Banner-modal"
                                                                onClick={() => handleUpdateBanner(item)}
                                                            >
                                                                <a className="dropdown-item text-xs5 font-normal text-start text-[#555259] w-full inline-block" href="#">Edit</a>
                                                            </li>
                                                            <li
                                                                className="px-5 py-1.5"
                                                                data-testid={`banner-deactivate-${i}`}
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#deactivateUserModal"
                                                                onClick={() => { setActiveObj(item); setActivateBannerModal(true); }}
                                                            >
                                                                <a
                                                                    className="dropdown-item text-xs5 font-normal text-start text-[#555259] w-full inline-block"
                                                                    href="#"
                                                                >
                                                                    {item.status === 1 ? 'Deactivate' : 'Activate'}
                                                                    {' '}
                                                                </a>
                                                            </li>
                                                            <li
                                                                className="px-5 pt-1.5 pb-5"
                                                                data-testid={`banner-delete-${i}`}
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#deleteUserModal"
                                                                onClick={() => handleDelete(item)}
                                                            >
                                                                <a className="dropdown-item text-xs5 font-normal text-start text-[#555259] w-full inline-block" href="#">Delete</a>
                                                            </li>
                                                        </ul>
                                                    )}

                                                </div>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                    )}
                    {!loading && promotionList && promotionList.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            totalPage={totalPage}
                            List={alldata}
                            currentPage={currentPage}
                        />
                    )}
                    {addBannerModal && (
                        <AddBannerModal
                            addBannerModal={addBannerModal}
                            setAddbannerModal={setAddbannerModal}
                            // bannerselected={bannerselected}
                            // setbannerselected={setbannerselected}
                            bannerDetails={bannerDetails}
                            setBannerDetails={setBannerDetails}
                            handleUploadBanner={handleUploadBanner}
                            isEditState={isEditState}
                            setIsEditState={setIsEditState}
                            selectedBannner={selectedBannner}
                            errorIndication={errorIndication}
                            setErrorIndication={setErrorIndication}
                            threeDotLoader={threeDotLoader}
                            setThreeDotsLoader={setThreeDotsLoader}
                        />
                    )}
                    {deleteBannermodal && (
                        <DeleteBannerModal
                            deleteBannermodal={deleteBannermodal}
                            setDeleteBannerModal={setDeleteBannerModal}
                            item={activeObj}
                            handleDeletePromotion={handleDeletePromotion}
                            threeDotLoader={threeDotLoader}
                            setThreeDotsLoader={setThreeDotsLoader}
                        />
                    )}
                    {activateBannerModal && (
                        <ActivateBanner
                            activateBannerModal={activateBannerModal}
                            setActivateBannerModal={setActivateBannerModal}
                            item={activeObj}
                            handleUpdatePromotion={handleUpdatePromotion}
                            setUpdateObj={setUpdateObj}
                            updateObj={updateObj}
                            threeDotLoader={threeDotLoader}
                            setThreeDotsLoader={setThreeDotsLoader}
                        />
                    )}
                    {filterModal && (
                        <FilterModal
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            selected={selected}
                            setselected={setselected}
                            filterValue={filterValue}
                            setfilterValue={setfilterValue}
                            handleFilter={handleFilter}
                            SetSuccessMessage={SetSuccessMessage}
                        />
                    )}
                    {emptyData && (
                        <EmptyScreen
                            search="yes"
                            all={debouncedSearch !== '' ? 'under searched term' : 'found'}
                            text=" no Promotions "
                            buttonRequired={false}
                        />
                    )}
                </div>
            )}

        </div>
    );
}

export default PromotionList;
